import * as React from "react";

export default () => {
  return <div>Övrig information</div>;
};
